import * as React from 'react';
import styles from './tile-info.scss';
import { ids } from 'app/area/administration/constants';

interface TileInfoComponentProps {
  id?: number;
  personId?: string;
  email?: string;
  mainGroup?: string;
  role?: string;
}

export const TileInfo: React.FC<TileInfoComponentProps> = ({
  id, personId, email, mainGroup, role
}) => (
    <div className={styles.tileInfo}>
      <ul className={styles.tileInfoContent}>
        {!!id && <li className={styles.tileId}>#{id}</li>}
        {!!personId && <li id={ids.search.personId} className={styles.tilePersonId}>{personId}</li>}
        {!!email && <li><span className="default-icon email" />{email}</li>}
        {!!role && <li>{role}</li>}
        {!!mainGroup && <li><span className="default-icon user-group" />{mainGroup}</li>}
      </ul>
    </div>
  );
